import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/fleet/$aircraftId/_aircraft")(
  {
    component: lazyRouteComponent(
      () => import("#pages/authenticated/fleet/[aircraftId]/aircraft-layout.tsx"),
      "AircraftLayout",
    ),
  },
)
